module.exports = __webpack_public_path__ + "img/ring_r_l_null_0.f75d3fd7.png";